import React, { useEffect } from "react";
import styled from "styled-components";

import FloatBoxStoreButton from "../components/floatBoxStoreButton";

require("dotenv").config();

export default function NotFound() {
  useEffect(() => {
    document.title = "WindRadar - Não Encontrado";
  }, []);

  return (
    <Page>
      <Content>
        <Status>404</Status>
        <Title>Ops, página não encontrada</Title>
        <Text>
          O link que você acessou pode ter expirado, mudado de endereço ou não
          estar disponível.
        </Text>
      </Content>

      <InstallPanel>
        <FloatBoxStoreButton
          marginTop="0"
          messageText="Instale o WindRadar e acompanhe as condições em tempo real."
        />
      </InstallPanel>
    </Page>
  );
}

const Page = styled.main`
  min-height: 100vh;
  box-sizing: border-box;
  padding: 40px 20px;
  background:
    radial-gradient(
      circle at top left,
      rgba(34, 117, 255, 0.18),
      transparent 34rem
    ),
    linear-gradient(135deg, #07111f 0%, #111827 48%, #06130e 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  font-family: Montserrat, Arial, sans-serif;

  @media (max-width: 640px) {
    padding: 28px 14px;
    justify-content: flex-start;
  }
`;

const Content = styled.section`
  width: min(720px, 100%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
`;

const Status = styled.div`
  color: #60a5fa;
  font-size: clamp(72px, 18vw, 180px);
  font-weight: 800;
  line-height: 0.85;
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(28px, 5vw, 56px);
  line-height: 1.05;
  font-weight: 800;
`;

const Text = styled.p`
  max-width: 620px;
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: clamp(16px, 2.4vw, 22px);
  line-height: 1.5;
`;

const InstallPanel = styled.section`
  width: min(520px, 100%);
  min-height: 184px;
  position: relative;
  display: flex;
  justify-content: center;

  > div > div {
    width: min(500px, calc(100vw - 28px)) !important;
    position: relative !important;
    top: auto !important;
    margin-top: 0 !important;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.92);
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.32);
    color: #111827;
  }

  @media (max-width: 640px) {
    min-height: 210px;

    > div > div {
      padding: 8px !important;
    }
  }
`;
